import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";
import { API_BASE_URL } from "views/api"

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
// Sections for this page
const useStyles = makeStyles(styles);

const culture_and_heritage_map = {
  'religious_and_cultural_heritage': 'धार्मिक तथा सांस्कृतिक महत्वका क्षेत्रहरु',
  'historical_places': 'ऐतिहासिक महत्वका क्षेत्रहरु',
  'natural_heritages': 'प्राकृतिक सम्पदाहरु',
  'special_festivals': 'विशिष्ट साँस्कृतिक पर्वहरु'
}
const culture_and_heritage_link = (selected_data)=> {return({
  'bhaktapur_ddc': API_BASE_URL + 'introduction/culture-and-heritage/?administrative_unit=bhaktapur_district&type='+selected_data,
  'changunarayan_municipality': API_BASE_URL + 'introduction/culture-and-heritage/?administrative_unit=changunarayan&type='+selected_data,
  'bhaktapur_municipality': API_BASE_URL + 'introduction/culture-and-heritage/?administrative_unit=bhaktapur&type='+selected_data,
  'madhyapur_thimi_municipality': API_BASE_URL + 'introduction/culture-and-heritage/?administrative_unit=madhyapur_thimi&type='+selected_data,
  'suryabinayak_municipality': API_BASE_URL + 'introduction/culture-and-heritage/?administrative_unit=suryabinayak&type='+selected_data
});}

export default function ProductSection(props) {
  const classes = useStyles();
  const [selected_culture_and_heritage, setCultureAndHeritage] = React.useState('religious_and_cultural_heritage');
  const [culture_and_heritage_list, setCultureAndHeritageList] = React.useState(undefined);
  const [selected_culture_and_heritage_item, setCultureAndHeritageItem] = React.useState(0);

  React.useEffect(() => {
    if (culture_and_heritage_list === undefined) {
      fetch(culture_and_heritage_link(selected_culture_and_heritage)[props.selected_data])
        .then(results => results.json())
        .then(data => {
          setCultureAndHeritageList(data.results);
        });
    }
  });

  return (
    <div style={{ backgroundColor: '#eee', padding: '15px', paddingRight: '25px' }}>
      <GridContainer>
        <GridItem className={classes.description} style={{ color: '#333' }}>
          <h3><b style={{ color: '#555' }}>संस्कृति तथा सम्पदा</b></h3>
          <GridContainer justify="center">
            <span>
              <h4>संस्कृति तथा सम्पदा छान्नुहोस:</h4>
            </span>
            <span>
              <CustomDropdown
                noLiPadding
                buttonText=<h4>{culture_and_heritage_map[selected_culture_and_heritage]}</h4>
                buttonProps={{
                  className: classes.navLink,
                  style: { padding: 0, margin: 0, marginLeft: '5px', backgroundColor: '#ddd', color: '#333', paddingLeft: '5px', paddingRight: '5px'}
                }}
                dropdownList={[
                  <Button color="transparent" fullWidth onClick={()=>{setCultureAndHeritageItem(0); setCultureAndHeritageList(undefined);setCultureAndHeritage('religious_and_cultural_heritage')}}>
                     धार्मिक तथा सांस्कृतिक महत्वका क्षेत्रहरु
                  </Button>,
                  <Button color="transparent" fullWidth onClick={()=>{setCultureAndHeritageItem(0); setCultureAndHeritageList(undefined);setCultureAndHeritage('historical_places')}}>
                    ऐतिहासिक महत्वका क्षेत्रहरु
                  </Button>,
                  <Button color="transparent" fullWidth onClick={()=>{setCultureAndHeritageItem(0); setCultureAndHeritageList(undefined);setCultureAndHeritage('natural_heritages')}}>
                    प्राकृतिक सम्पदाहरु
                  </Button>,
                  <Button color="transparent" fullWidth onClick={()=>{setCultureAndHeritageItem(0); setCultureAndHeritageList(undefined);setCultureAndHeritage('special_festivals')}}>
                    विशिष्ट साँस्कृतिक पर्वहरु
                  </Button>
                ]}
              />
            </span>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {culture_and_heritage_list && culture_and_heritage_list.length === 0 ? <h3 style={{ backgroundColor: 'white', paddingTop: '90px', 'height': '200px' }}>उपलब्ध छैन</h3>:
      <GridContainer className={classes.description} style={{ color: '#333', marginTop: '10px' }}>
        <GridItem md={3} sm={4} xs={4}>
          {culture_and_heritage_list && culture_and_heritage_list.map((item, i) =>
            <Button
              color={selected_culture_and_heritage_item === i ? "primary": "transparent"}
              fullWidth
              style={{ margin: 0, padding:'5px' }}
              onClick={() => setCultureAndHeritageItem(i)}
            >
              {item.name}
            </Button>
          )}
        </GridItem>
        <GridItem md={9} sm={8} xs={8} style={{ backgroundColor:'#fff', textAlign: 'left', padding: '20px', maxHeight: '400px', minHeight: '250px', overflowY: 'auto' }}>
          {culture_and_heritage_list && culture_and_heritage_list[selected_culture_and_heritage_item] && culture_and_heritage_list[selected_culture_and_heritage_item].image !== null && <GridItem md={6} sm={6} xs={12} style={{ float: 'right' }}><img style={{width: '100%'}}  src={culture_and_heritage_list[selected_culture_and_heritage_item].image} /></GridItem>}
          <p>{culture_and_heritage_list && culture_and_heritage_list[selected_culture_and_heritage_item] && culture_and_heritage_list[selected_culture_and_heritage_item].description}</p>
        </GridItem>
      </GridContainer>}
    </div>
  );
}
